<div class="status color generalstatus" [ngClass]="generalClass"></div>
<div class="content">
    <div class="banner slot-overbooked-banner">{{ 'SLOTSERVICE.ERROR.OVERBOOKING' | translate }}</div>
    <ng-content></ng-content>
    <div class="banner slot-invalidreservation-banner">{{ 'SLOTSERVICE.ERROR.INVALIDRESERVATION' | translate }}</div>
    <ng-content></ng-content>
    <div class="banner slot-linkedslot-banner">{{ 'SLOTSERVICE.INFO.LINKEDSLOT' | translate }}</div>
    <ng-content></ng-content>
    <div class="banner slot-slotNotRecomendable-banner">{{ 'SLOTSERVICE.INFO.SLOTNOTRECOMENDABLE' | translate }}</div>
    <ng-content></ng-content>
</div>